import { useEffect } from "react";
import { useSelector } from "react-redux";

import { getFacilityContext } from "@/utils/route-context";
import { registerAiChartContext, unregisterAiChartContext } from "./pageContext";

const AiChartContextRegistration = ({ context }) => {
  const { companyId, facilityId } = useSelector((state) => getFacilityContext(state));
  const serialized = JSON.stringify(context || null);

  useEffect(() => {
    if (!context) return;
    registerAiChartContext({
      companyId,
      facilityId,
      pageId: context.pageId,
      chart: context.chart,
    });
    const chartId = context.chart?.chart_id;
    return () =>
      unregisterAiChartContext({
        companyId,
        facilityId,
        pageId: context.pageId,
        chartId,
      });
  }, [companyId, facilityId, context?.pageId, serialized]);

  return null;
};

export default AiChartContextRegistration;
